import { render } from "./Swap.vue?vue&type=template&id=1a159b32"
import script from "./Swap.vue?vue&type=script&lang=js"
export * from "./Swap.vue?vue&type=script&lang=js"

import "./Swap.vue?vue&type=style&index=0&id=1a159b32&lang=scss"

import exportComponent from "C:\\Proyectos\\Crypto\\dex\\github\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__